import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'bm',
    fullName: 'Bambara',
    nativeName: 'Bamanakan',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid (AgVoid) ye",
    landing_title: "Kabako dɔ bɛ ka na",
    landing_subtitle: "ArgVoid ye app ni tulon yiriwali studio ye. Aw ka to aw ɲɛ na, fɛn kuraw bɛ na yanni dɔɔnin cɛ!",
    select_language: "Kan sugandi",
    search_placeholder: "Kanw ɲinini...",
    terms_title: "Baarakɛcogo sariyaw",
    policy_title: "Kunnafoni dogolenw maracogo",
    cookies_title: "Kukisɛw ka sariya",
    terms_content: `
        <strong>1. Sɔn Sariyaw ma</strong><br>
        Ni i donna ArgVoid la, nin Baarakɛcogo sariyaw bɛ sɔn. Ni nin sariyaw ma bɛn, baara man kan ka kɛ ni baarakɛminɛn ye.<br><br>

        <strong>2. Plateforme Baarakɛcogo</strong><br>
        ArgVoid n'a ka baarakɛminɛnw bɛ di "i n'a fɔ a bɛ cogo min na" kunnafonidi ni daɲɛw dilanni kama. Baara ka kan ka baara kɛ ni sariya siratigɛ la dɔrɔn.<br><br>

        <strong>3 ye. Taamacogo dagalen</strong><br>
        Site ka bɔnɛw nafabɔli, ka spam, walima k’a ɲini ka don infrastructures kɔnɔ ni yamaruya tɛ, o dagalen don kosɛbɛ.<br><br>

        <strong>4 ye. Kɔrɔfɔli</strong><br>
        Plateforme ni baarakɛminɛnw bɛ se ka ladilan waati o waati k’a sɔrɔ i ma fɔ. Garanti si tɛ di ka ɲɛsin baara kɛcogo ma walima a kɛcogo ma.
    `,
    policy_content: `
        <strong>1. Kunnafoni Lajɛ</strong><br>
        Plateforme tɛ baarakɛlaw ka dantigɛli walima jatebɔsɛbɛn dabɔli wajibiya nin waati in na. Mɔgɔ yɛrɛ ka kunnafoni si (i n’a fɔ tɔgɔw walima imɛri ladɛrɛsi) si tɛ lajɛ ni timinandiya ye ka bɔ taamakɛlaw yɔrɔ.<br><br>

        <strong>2. Baarakɛcogo Data</strong><br>
        Sɛgɛsɛgɛli jɔnjɔnw, minnu tɔgɔ ma fɔ, olu bɛ se ka lajɛ walasa ka sitiw ka taama faamuya ani ka baarakɛminɛnw ɲɛ. Nin kunnafoniw tɛ tali kɛ baarakɛla kelen-kelen bɛɛ ka danyɔrɔw la.<br><br>

        <strong>3 ye. Baarakɛminɛn sabananw</strong><br>
        Baara bɛ se ka kɛ ni mɔgɔ sabananw ka baarakɛminɛnw ye jatigila ni jateminɛ baara kama. O dɛmɛbaga kelen-kelen bɛɛ ka danbeko kɛcogo bɛ kunnafoniw ɲɛminɛ minnu tɛ tɔgɔ ye, minnu bɛ baara kɛ u ka fɛnsɔrɔsiraw kan.<br><br>

        <strong>4 ye. Donanw Lakanali</strong><br>
        Lakanali fɛɛrɛ bɛnnenw bɛ tigɛ walasa ka plateforme lakana. Nka, kunnafoni cicogo si tɛ ɛntɛrinɛti kan min lakananen don pewu.<br><br>
    `,
    cookies_content: `
        <strong>1. Kukisɛw ni sigida marali ye mun ye?</strong><br>
        Cookies ani browser local storage ye data files misɛnninw ye minnu maralen bɛ minɛn kɔnɔ walasa ka hakili to labɛncogo fɛɛrɛw la taamaw bɛɛ kɔnɔ.<br><br>

        <strong>2. Baarakɛcogo Kun</strong><br>
        Browser LocalStorage bɛ baara kɛ kosɛbɛ walasa ka labɛncogo dɔw mara, i n’a fɔ:<br>
        - Kanko fɛɛrɛw<br>
        - Baarakɛminɛnw labɛncogo (misali la, layidu walima barokun sigicogo)<br>
        - Waati dɔɔnin kɔnɔ baarakɛminɛnw cache<br><br>

        <strong>3 ye. No Tracking</strong><br> ye
        Cookies ani sigida marayɔrɔw tɛ kɛ piblisite walima mɔgɔ wɛrɛw ka tugu-tugu-ɲɔgɔn kɔ. Donan maralenw bɛɛ bɛ kɛ ka ɲɛsin plateforme ka baarakɛcogo jɔnjɔn ma.<br><br>

        <strong>4 ye. Kunnafoni </strong><br>
        Navigatɛri ka kunnafoniw bɛ se ka saniya waati o waati navigatɛri labɛncogo fɛ, o bɛna sigida labɛncogo bɛɛ lasegin.
    `,
    cookie_consent_text: "An bɛ baara kɛ ni cookies jɔnjɔnw ye walasa ka a lajɛ ni site web baara ka ɲɛ, i n’a fɔ ka i ka session to baara la, k’i ka kan diyabɔcogo mara, ani ka i ka kanw labɛncogo wɛrɛw labɛn ka kɛɲɛ ni i yɛrɛ sago ye.",
    read_policy: "Aw ye Cookie Policy kalan",
    support_title: "Aw ye ɲɔgɔn sɔrɔ Dɛmɛbagaw fɛ",
    support_subject_label: "Walekɛlan",
    support_message_label: "Bataki",
    support_submit_button: "Cikan ci",
    support_hint: "Kɔlɔsili: O bɛna i ka imayili porogaramu da wuli walasa ka cikan ci.",
    support_success_msg: "Ka i ka email app da wuli...",
    support_error_msg: "A ma se ka cikan ci. Aw ye aw jija ka segin ka a lajɛ kɔfɛ.",
    explorer_title: "Explorer (Sɛgɛsɛgɛlikɛla).",
    history_title: "Tariku",
    animation_title: "Animation (ɲɛnamaya kɛcogo) ye",
    config_title: "Labɛnni (Configuration) (Labɛnni).",
    tool_mouse: "A’ ye (Ctrl+M) sugandi.",
    tool_brush: "Burusi (Ctrl+B) ye.",
    tool_brush_mode: "Toggle Mode (Solid/Clear) Bamako, Mali.",
    tool_eraser: "Furakɛlan (Ctrl+E) .",
    tool_brush_size: "Aw bɛ Brush Size ladilan",
    tool_bucket: "Fasa (Ctrl+F) .",
    tool_eyedropper: "Ɲɛkisɛ-bɔlan",
    tool_grid: "Grid (Ctrl+Shift+B) ye .",
    tool_rotate: "Yɛlɛma (Ctrl+Shift+R) .",
    tool_flip_h: "Flip H (Ctrl+Shift+H) Bamako, Mali.",
    tool_flip_v: "Flip V (Ctrl+Shift+V) Bamako, Mali.",
    tool_transpose: "Transpose (Ctrl+Shift+T) ye .",
    label_width: "Jayan",
    label_height: "Janya",
    label_frames: "Kalansenw hakɛ",
    label_animation: "Animatɛri cogoya",
    label_background_color: "Background Kulɛri",
    label_interval: "Interval (dakun) cɛ",
    tool_anim_config: "Animatɛriw labɛncogo",
    label_new_width: "Lajɛ kura",
    label_new_height: "Kɔrɔya kura",
    label_apply: "Ka waleya",
    label_colors: "Kulɛriw",
    label_size: "Kundama",
    label_tolerance: "Yafa",
    val_horizontal: "Dalen",
    val_vertical: "Jɔ̀len",
    val_sequence: "Dasigi",
    val_bounce: "Ka pan pan",
    val_random: "Kunfɛ",
    val_solid: "Jalen",
    val_clear: "Jɛman",
    action_add_sheet: "Sɛbɛn kura",
    action_import: "Ka ladon",
    action_export: "Ka labɔ",
    action_sort_projects: "Ka woloma",
    sort_date_old: "Kɔrɔlen Fɔlɔ",
    sort_date_new: "Kura fɔlɔ Fɔlɔ",
    sort_name_az: "Tɔgɔ (A-Z) .",
    sort_name_za: "Tɔgɔ (Z-A) .",
    action_new_sprite: "Sprite kura",
    action_new_project: "Porozɛ kura",
    modal_save_all_title: "Yɛlɛma bɛɛ mara",
    modal_save_all_desc: "Nafolo minnu bɛna mara, olu sugandi:",
    modal_save_selected: "Save Selected (Sɔrɔlen sugandilenw).",
    action_saved: "Kisilen don",
    modal_create_sprite_title: "Sprite Kura Dabɔ",
    modal_create_project_title: "Porozɛ kura dabɔ",
    modal_add_sheet_title: "Aw ye sɛbɛn kura fara a kan",
    modal_rename_sheet_title: "Tɔgɔ caman cili sɛbɛnfura la",
    modal_rename_sprite_title: "Sprite tɔgɔ caman wɛrɛ",
    modal_delete_sprite_title: "Sprite (Sprite) bɔ yen",
    modal_delete_project_title: "Porozɛ min bɛ bɔ yen",
    modal_delete_sheet_title: "Delete Sheet (Sɛbɛn) min bɛ bɔ",
    placeholder_sprite_name: "Tɔ̀gɔ",
    placeholder_project_name: "Tɔ̀gɔ",
    placeholder_sheet_name: "Tɔ̀gɔ",
    placeholder_new_name: "Tɔgɔ kura",
    action_create: "Ka dilan",
    action_add: "Ka fara kan",
    action_rename: "Tɔgɔ caman wɛrɛ",
    action_duplicate: "Duplicate (Duplicate) kɛ",
    action_delete: "Ka jɔsi",
    action_cancel: "ka dankari",
    confirm_delete_sprite: "Yala aw dalen b’a la ko aw b’a fɛ ka nin sprite in bɔ yen wa?",
    confirm_delete_project: "Yala aw dalen b’a la ko aw b’a fɛ ka nin poroze in bɔ yen wa? Sprite bɛɛ bɛna bɔ yen.",
    confirm_delete_sheet: "Yala aw dalen b’a la ko aw b’a fɛ ka nin sɛbɛn in bɔ yen wa?",
    err_select_sprite: "Aw ye sprite dɔ sugandi fɔlɔ.",
    err_select_project: "Aw ye poroze dɔ sugandi fɔlɔ.",
    err_name_empty: "Tɔgɔ tɛ se ka kɛ lankolon ye.",
    err_sprite_exists: "Sprite (sprite) min tɔgɔ ye o ye, o bɛ yen kaban.",
    err_project_exists: "Porozɛ min tɔgɔ ye o ye, o bɛ yen kaban.",
    err_no_content: "Kɔnɔkow si tɛ yen ka mara.",
    err_no_changes: "Yɛlɛma si ma kɛ ka kisi.",
    err_delete_last_sheet: "Se tɛ ka sɛbɛn laban bɔ.",
    err_extract_frames: "A ma se ka frame si bɔ.",
    err_indexeddb: "A ma se ka kisi sigida la. N’a sɔrɔ i ka navigatɛri tɛ IndexedDB dɛmɛ.",
    msg_upload_success: "Upload (Tupload) ye ɲɛtaa sɔrɔ: {0}",
    msg_upload_failed: "Upload ma ɲɛ: {0}",
    msg_save_success: "Save ka ɲɛtaa sɔrɔ.",
    msg_saving: "Saving...",
    msg_multi_save_result: "Nafolo {0} maralenw. {1} dɛsɛw.",
    menu_title: "Meniw (Menu) kɔnɔ",
    menu_save: "Ka mara",
    menu_save_all: "Save Bɛɛ",
    menu_support: "Aw ye ɲɔgɔn sɔrɔ Dɛmɛbagaw fɛ",
    label_local_storage: "Sigida Lakanali",
    label_sign_in: "I ka don a kɔnɔ",
    modal_export_title: "Sprite (Sprite) ka bɔ jamana wɛrɛw la",
    label_filename: "Filen tɔgɔ",
    label_format: "Fɔcogo",
    action_export_confirm: "Ka labɔ",
};

export default translations;
